import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '@/components/common/PageHeader';
import { DataGrid, type DataGridColumn } from '@/components/tables/DataGrid';
import { formatDateTime } from '@/utils/format';
import { editLogsApi, type EditLogRowDto } from '@/api/services/editLogs';

export function EditLogsPage() {
  const query = useQuery({ queryKey: ['edit-logs', 'logs'], queryFn: editLogsApi.getLogs });

  return (
    <div className="edit-logs-page">
      <PageHeader title="Edit Logs" breadcrumb={['Home', 'Edit Logs']} />
      <DataGrid
        columns={[
          { key: 'editDate', title: 'Edit Date', className: 'text-start', value: (r) => r.editDate, cell: (r) => formatDateTime(r.editDate) },
          { key: 'user', title: 'User', className: 'text-start', value: (r) => r.user },
          { key: 'ticket', title: 'Ticket', className: 'text-start', value: (r) => r.ticket },
          { key: 'login', title: 'Login', className: 'text-start', value: (r) => r.login },
          { key: 'transactionDate', title: 'Transaction Date', className: 'text-start', value: (r) => r.transactionDate, cell: (r) => formatDateTime(r.transactionDate) },
          { key: 'oldProvider', title: 'Old Provider', className: 'text-start', value: (r) => r.oldProvider },
          { key: 'newProvider', title: 'New Provider', className: 'text-start', value: (r) => r.newProvider },
          { key: 'oldProviderType', title: 'Old Provider Type', className: 'text-start', value: (r) => r.oldProviderType },
          { key: 'newProviderType', title: 'New Provider Type', className: 'text-start', value: (r) => r.newProviderType },
          { key: 'connector', title: 'Connector', className: 'text-start', value: (r) => r.connector },
          { key: 'comment', title: 'Comment', className: 'text-start', value: (r) => r.comment },
        ] as DataGridColumn<EditLogRowDto>[]}
        data={query.data ?? []}
        rowKey={(r) => `${r.editDate}-${r.ticket}-${r.login}`}
        card
        columnSearch
        includeExcel
        excelFileName="Edit Logs"
        emptyMessage={query.isLoading ? 'Loading…' : 'No data.'}
      />
    </div>
  );
}
